import './css/dashboardtable.css';
import './css/editform.css';
import React, { useState,useEffect} from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation, useParams } from 'react-router-dom';
import ShowButton from '../ShowButton';






function AddLandingSlide(){


        
    useEffect(() => {
        axios
    .get('session')
    .then((res) => {
        if (res.data.valid) {

            if(res.data.type == "admin"){
            }else{
                navigate('/admin-login');
            }

        } else {

        }
    })
    .catch((err) => console.log(err));
    },[]);





    const navigate = useNavigate();


    
    const [header, setHeader] = useState("");
    const [header_ar, setHeaderar] = useState("");
    const [header_ch, setHeaderch] = useState("");

    const [sec_header, setSecheader] = useState("");
    const [sec_header_ar, setSecheaderar] = useState("");
    const [sec_header_ch, setSecheaderch] = useState("");


    
    const [para, setPara] = useState("");
    const [para_ar, setParaar] = useState("");
    const [para_ch, setparach] = useState("");



    const [img, setImg] = useState("");


    const handleSubmit = (event) => {
        event.preventDefault();

        let Loading = document.querySelector(".loading-screen"); 
        Loading.classList.add("active");

        const data = new FormData();


        data.append("header", header || "");
        data.append("header_ar", header_ar || "");
        data.append("header_ch", header_ch || "");

        data.append("sec_header", sec_header || "");
        data.append("sec_header_ar", sec_header_ar || "");
        data.append("sec_header_ch", sec_header_ch || "");

        
        data.append("para", para || "");
        data.append("para_ar", para_ar || "");
        data.append("para_ch", para_ch || "");


        if (img) {
            data.append("img", img);
        }
    
    
        const config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        };
    
        axios
        .post("/add-landing-slide", data, config)
        .then((response) => {
            
            Loading.classList.remove("active");

            let alertS = document.querySelector(".alert-success"); 
            alertS.classList.add("active");


            setTimeout(() => {
                alertS.classList.remove("active");
            }, 3000);


        })
        .catch((error) => {
            
            Loading.classList.remove("active");

            let alertD = document.querySelector(".alert-danger"); 
            alertD.classList.add("active");
            setTimeout(() => {
                alertD.classList.remove("active");
            }, 3000);
            console.log(error);
        });
    };
    


    axios.defaults.withCredentials = true;



    const getIfLogin= ()=>{
        
    axios
    .get('session')
    .then((res) => {
        if (!res.data.valid) {
            navigate('/admin-login');

        }
        
    })
    .catch((err) => console.log(err));

    }




    useEffect(() => {
        getIfLogin();
    }, []);
    




    

    return(
        <>

                    <div className='loading-screen'>
                            <div class="loader">
                                <div class="outer"></div>
                                <div class="middle"></div>
                                <div class="inner"></div>
                            </div>

                        </div>
            <section className='dashboard'>



                <div className='edit-form'>

                    <div className='alert-success'>
                        <h1> Data Added successfully  <i class="las la-check-circle"></i></h1>
                    </div>

                    <div className='alert-danger'>
                        <h1> Failed To Add Data <i class="las la-exclamation-triangle"></i></h1>

                    </div>

                    <h1> Add HomePage Slide </h1>

                    <form onSubmit={handleSubmit}>

                        
                    <div className='input'>
                        <label> Header  </label>
                        <input  onChange={(event) => setHeader(event.target.value)} type='text' required="required"  maxLength="200" name='header'/>
                    </div>

                    
                    <div className='input'>
                        <label> header ( arabic )  </label>
                        <input  onChange={(event) => setHeaderar(event.target.value)} type='text' required="required"  maxLength="200" name='header_ar'/>
                    </div>


                    <div className='input'>
                        <label> header ( japan ) </label>
                        <input  onChange={(event) => setHeaderch(event.target.value)} type='text' required="required"  maxLength="200" name='header_ch'/>
                    </div>

                    <div className='input'>
                        <label> Sub Header  </label>
                        <input  onChange={(event) => setSecheader(event.target.value)} type='text' required="required"  maxLength="200" name='sec_header'/>
                    </div>

                    
                    <div className='input'>
                        <label> Sub header ( arabic )  </label>
                        <input  onChange={(event) => setSecheaderar(event.target.value)} type='text' required="required"  maxLength="200" name='sec_header_ar'/>
                    </div>


                    <div className='input'>
                        <label> Sub header ( japan ) </label>
                        <input  onChange={(event) => setSecheaderch(event.target.value)} type='text' required="required"  maxLength="200" name='sec_header_ch'/>
                    </div>




                    <div className='input'>
                        <label> Text  </label>
                        <textarea  onChange={(event) => setPara(event.target.value)} type='text' required="required"  maxLength="700" name='para'>
                            
                        </textarea>
                    </div>

                    
                    <div className='input'>
                        <label> Text ( arabic )  </label>
                        <textarea  onChange={(event) => setParaar(event.target.value)} type='text' required="required"  maxLength="700" name='para_ar'>
                            
                        </textarea>                    
                    </div>


                    <div className='input'>
                        <label> Text ( japan ) </label>
                        <textarea  onChange={(event) => setparach(event.target.value)} type='text' required="required"  maxLength="700" name='para_ch'>
                            
                        </textarea>
                    </div>





                    <div className='input'>
                        <label> Image  </label>
                        <input onChange={(event) => setImg(event.target.files[0])} type='file' name="img" accept="image/*"/>
                    </div>

                
                    <button type='submit'> Save </button>

                    </form>
                </div>
            </section>
        
        </>
    )
}

export default AddLandingSlide;